import { BlockEntity, BombBlockEntity } from '../../entities/BlockEntity';
import { GameScene } from '../../GameScene';
import { BombEffect } from './BombEffect';
import { IEffect } from './IEffect';
import { MergeEffect } from './MergeEffect';

// types
//-----------------------------------------------------------------------------
export type BombBombComboEffectOptions = {
  subject: BombBlockEntity;
  pair: BlockEntity[];
  all: BlockEntity[];
};

/*
    bomb+bomb combo explosion effect
*/
export class BombBombComboEffect implements IEffect {
  // fields
  //-------------------------------------------------------------------------
  // input
  private readonly _scene: GameScene;
  private readonly _options: BombBombComboEffectOptions;

  // init
  //-------------------------------------------------------------------------
  constructor(scene: GameScene, options: BombBombComboEffectOptions) {
    this._scene = scene;
    this._options = options;
  }

  // impl
  //-------------------------------------------------------------------------
  public async execute() {
    const position = this._options.subject.c.position.mapPosition;

    // merge all blocks
    await new MergeEffect(this._scene, this._options.all, position).execute();

    // execute large bomb effect at position of first block
    return new BombEffect(this._scene, {
      position,
      radius: 3,
      big: true,
    }).execute();
  }
}
